// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-container[data-v-71f7d46c]{margin:0;display:flex;list-style-type:none;align-items:stretch;justify-content:flex-start;padding:0}.nav-container--old-design[data-v-71f7d46c]{-moz-column-gap:25px;column-gap:25px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
